<script>
import EggMobileChooser from '@/layerAdmin/components/EggMobileChooser.vue';

export default {
  components: {
    EggMobileChooser,
  },

  props: {
    batch: { type: Object, required: true },
  },

  data: function () {
    return {
      numberPlaced: this.batch.number_placed,
      eggMobiles: this.batch.egg_mobiles,
    };
  },

  computed: {
    validationError() {
      if (isNaN(this.numberPlaced) || Number(this.numberPlaced) === 0) return 'Please enter the Number of Chicks Placed';
      if (!this.eggMobiles || this.eggMobiles.length === 0) return 'Please select at least one Egg Mobile';
    }
  },

  watch: {
    batch(to) {
      this.numberPlaced = to.number_placed;
      this.eggMobiles = to.egg_mobiles;
    },
  },
}
</script>

<template>
  <div>

    <b-card>

      <api-form
        method="put"
        :url="`v1/layeradmin/batches/${encodeURIComponent(batch.name)}`"
        :payload="{ number_placed:numberPlaced, egg_mobiles:eggMobiles}"
        submit-text="Save"
        :validation-error="validationError"
        :make-success-message="(batch) => `Batch ${batch.name} successfully saved.`"
        @success="$emit('update', $event);"
        @cancel="$emit('cancel')"
        v-slot="{busy}">

        <b-form-group label="Number of Chicks Placed" :label-for="`number-date-${_uid}`">
          <b-form-input :id="`number-date-${_uid}`" v-model="numberPlaced" type="number" min="1" required @focus="$event.target.select()" :disabled="busy"></b-form-input>
        </b-form-group>

        <egg-mobile-chooser v-model="eggMobiles" multiple required />

      </api-form>

    </b-card>

    <b-card class="mt-3">
      <div class="d-flex justify-content-center">

        <confirm-click class="w-100">
          <api-button
            method="delete"
            :url="`v1/layeradmin/batches/${batch.name}`"
            :payload="{}"
            class="btn btn-outline-danger btn-block "
            @executed="$emit('delete')">
            <i class="fa fa-trash-o"></i>
            Archive
          </api-button>
        </confirm-click>

      </div>
    </b-card>

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/LayerBatchManage.vue